<template>
    <div class="bg-white">
        <div class="container flex justify-center">
            <div
                v-for="(tab, i) in tabs"
                :key="i"
                class="mx-3"
                :class="activeTab === tab.value ? 'toggled' : ''"
                @click="$emit('update-facet', [tabsField, tab.value])"
            >
                <div class="tab">
                    <button>{{ tab.label }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabsField: {
            type: String,
            required: true
        },
        activeTab: {
            type: String,
            default: ''
        },
        scopedFacets: {
            type: Object,
            required: true
        }
    },

    computed: {
        tabs() {
            if (!this.scopedFacets[this.tabsField]) return [];
            return [...this.scopedFacets[this.tabsField]].sort((a, b) =>
                a.position > b.position ? -1 : 1
            );
        }
    }
};
</script>
